module.exports = __webpack_public_path__ + "img/background-crew-desktop.3ea64989.jpg";